import { IAnimManager } from './anim-manager.interface';
export default class AnimManager implements IAnimManager {
    public editSlideComponent;
    public playSlideComponent;
    public constructor() {
        this.editSlideComponent = undefined;
        this.playSlideComponent = undefined;
    }
}
